import { Action } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { Observable } from 'rxjs';
import {
  map, pluck, tap, ignoreElements, first, filter,
} from 'rxjs/operators';

import { gameActions, tableActions } from '../../actions';
import { chipsSelector } from '../../selectors';
import { RootState } from '../../types';

const { selectChip } = gameActions;
const { table } = tableActions;

const chipSelection = (action$: Observable<Action>) => action$.pipe(
  filter(selectChip.request.match),
  pluck('payload'),
  map(selectChip.set)
);

const chipPreload = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(table.set.match),
  first(),
  tap(() => {
    const chips = chipsSelector(state$.value);

    chips.forEach((chip) => {
      const img = new Image();
      img.src = chip.img;
    });
  }),
  ignoreElements()
);

export default combineEpics(chipSelection, chipPreload);
